<script lang="ts">
    import {
        createOperationOut,
        getAttachement,
        getOneOperation,
        getOperation,
        getPriceCalculationByDealers,
        postAction,
        updateOperationOut,
    } from "../../../api"
    import { appliedPricegroups, filesStore, login, newNotification, operationHashBeginning } from "../../../store"
    import AttachementField from "../../widgets/fields/AttachementField.svelte"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import OperationHead from "./OperationHead.svelte"
    import OperationPositions from "./OperationPositions.svelte"
    import OperationsLegend from "./OperationsLegend.svelte"
    import ShareOperation from "./ShareOperation.svelte"
    import { openOverlay } from "../../../store"
    import CartIcon from "../../widgets/CartIcon.svelte"
    import Icon from "./../../widgets/Icon.svelte"
    import hash from "object-hash"
    import { mdiArchiveClock, mdiFileDocumentEdit, mdiFileDocumentMultiple, mdiEmailArrowRight } from "@mdi/js"
    import { createEventDispatcher, onDestroy, onMount } from "svelte"
    import OperationEdit from "./OperationEdit.svelte"
    import OperationSummary from "./edit/OperationSummary.svelte"
    import { operationSumEndcustomerPrice } from "../../../functions/operations/operationSumEndcustomerPrice"
    import PricegroupSelect from "./edit/PricegroupSelect.svelte"
    import { navigateTo, tooltip } from "../../../helper"
    import OperationTemplateOverlay from "./OperationTemplateOverlay.svelte"
    import { emitEvent, registerEventCallback, unregisterEventCallback } from "../../../eventBus"
    import { _ } from "svelte-i18n"
    import {
        checkIfEditTemplateIsDisabled,
        checkIfOfferConfirmationIsDisabled,
        checkIfOfferConvertionIsDisabled,
        checkIfOfferCreationIsDisabled,
        checkIfOperationDuplicationIsDisabled,
        checkIfOrderConfirmationConvertionIsDisabled,
        checkIfOrderedAndItsStatus,
        checkIfSaveIsDisabled,
        checkIfSendOfferIsDisabled,
        checkIfTemplateOnOpOrOnClerkIsAvailable,
        getCreateOfferConfirmationTooltip,
        getDuplicateOperationTooltip,
        getEditTemplateTooltip,
        getOfferConvertionTooltip,
        getOrderConfirmationConvertionTooltip,
        getResetTooltip,
        getSaveTooltip,
        getSendOfferConfirmationTooltip,
        getSendOfferTooltip,
        sendOfferConfirmation,
    } from "../../../functions/operations/OperationDetails"
    import { isOperationOut, toOperationOut } from "../../../functions/operations/typeGuards"
    import FollowUpButton from "../../widgets/FollowUpButton.svelte"
    export let id: string
    export let collectionName: string
    export let activePosition: number
    let loading = true
    let attachmentsProm: {
        [opNum: number]: Promise<{ count?: number; data: Attachement[] }>
    } = {}

    async function loadAttachments(op: Operation | OperationOut) {
        if (!attachmentsProm[op?.number]) {
            attachmentsProm[op?.number] = getAttachement(collectionName == "operation-out" ? op?.id : op?.number)
        }

        try {
            const res = await attachmentsProm[op?.number]
            if (isOperationOut(op)) {
                await getAttachement(op.refNumber || "").then((r) => {
                    r.data.forEach((f) => {
                        if (
                            f?.name?.toLowerCase()?.includes("jpg") ||
                            f?.name?.toLowerCase()?.includes("jpeg") ||
                            f?.name?.toLowerCase()?.includes("png")
                        ) {
                            if (res.data.find((e) => e.name == f.name)) return
                            res.data.push(f)
                        }
                    })
                })
            }
            $filesStore[id] = res.data
            return res.data
        } catch (e) {}

        return []
    }
    // operation from cart not from operation

    let op: OperationOut | Operation = $$props?.cartObj?.operations?.find((o: { id: string }) => o.id == id)
    let files: Attachement[] = null
    getOp()
    async function getOp(force = false) {
        let firstTime = !op
        op = await getOneOperation(id, collectionName)
        if (firstTime || force) {
            if (op.collectionName == "operation-out" && op.appliedPCalc) {
                if (op.appliedPCalc == "manual") {
                    let pCalc = op?.endCustomerFullAddress?.priceCalculationManual
                    if (pCalc) {
                        $appliedPricegroups[op.id] = [`Manuelle Angabe`, hash(op)]
                    }
                } else {
                    let response = await getPriceCalculationByDealers([
                        $login?.account?.ident?.dealerNumber || 0,
                        ...($login?.tokenData?.dealers || []),
                    ])
                    if (response.data.length) {
                        const pCalcs = response.data
                        pCalcs?.forEach((p) => {
                            if (p?.groupName && p?.id == (op as OperationOut).appliedPCalc) {
                                $appliedPricegroups[op.id] = [
                                    `${p.groupName || $_("components.operationDetails.globalPriceGroup")} - ${$_(
                                        "components.operationDetails.dealerNumber"
                                    )}: ${p.dealerNumber}`,
                                    hash(op),
                                ]
                            }
                        })
                    }
                }
            } else {
                delete $appliedPricegroups[op.id]
            }

            activePositions = op.positions.length
        }
        loading = false
    }
    async function createPDFAndGetOperation(operation: Operation | OperationOut): Promise<OperationOut> {
        await postAction(op.type == 1 ? "createOfferPDF" : "createOrderConfirmationPDF", operation).catch((e) => {
            newNotification({
                class: "error",
                html: `${
                    op.type == 1
                        ? $_("components.operationDetails.offerTemplate")
                        : $_("components.operationDetails.orderConfirmationTemplate")
                } ${$_("components.operationDetails.couldNotBeCreated")}: ${e?.message}`,
                timeout: 10000,
            })
        })
        let opOut = (await getOperation<OperationOut[]>("operation-out", { _id: operation.id }, 1, 0, "full")).data
        return opOut[0]
    }
    let clicked = false
    const saveOp = async (feedback: boolean) => {
        op = op as OperationOut
        loading = true
        const overlayContent = document.getElementsByClassName("overlaycontent")[0]
        if (overlayContent) {
            overlayContent.scrollTop = 0
            files = null
        }
        op?.additionalPositions?.forEach((p) => (p.netPrice = Number(p.netPrice)))
        op?.positions?.forEach((p) => {
            p.netPrice = Number(p.netPrice)
            p?.additionalItems?.forEach((s) => {
                s.netPrice = Number(s.netPrice)
            })
        })
        const res = await updateOperationOut(op)
            .then(async (res) => {
                // @ts-ignore
                const op = await createPDFAndGetOperation(res.data || res)
                emitEvent("operationUpdated", op)

                if (feedback) {
                    if (op?.statusSummary?.created !== 100) {
                        newNotification({
                            class: "warning",
                            html: `${$_("components.operationDetails.offerTemplate")} ${
                                op.type == 1
                                    ? $_("components.operationDetails.offer")
                                    : $_("components.operationDetails.orderConfirmation")
                            } ${$_("components.operationDetails.isNotCompleted")}`,
                        })
                    } else {
                        newNotification({
                            class: "success",
                            html: `${
                                op.type == 1
                                    ? $_("components.operationDetails.offer")
                                    : $_("components.operationDetails.orderConfirmation")
                            } ${$_("components.operationDetails.wasSuccessfullySaved")}`,
                        })
                    }
                }
                return op
            })
            .catch((e) => {
                if (feedback) {
                    newNotification({
                        class: "error",
                        html: `${$_("components.operationDetails.offerCouldNotBeSaved")}: ${e?.message}`,
                    })
                }
            })
            .finally(() => {
                loading = false
            })

        if (res) {
            op = res
            $operationHashBeginning = hash(op)
            operationHashCurrent = $operationHashBeginning
        }
    }
    const dispatch = createEventDispatcher()

    /**
     * `createOperationOut` legt die übergebene Operation als operation-out an
     * und entpackt die Hook-Antwort selbst (siehe api.ts) – der Rückgabewert
     * ist also bereits die angelegte Auftragsbestätigung.
     */
    const makeNewOperationOut = async (op: OperationOut, newTab = false) => {
        if (op.type == 1) delete op?.statusSummary?.emailed
        else delete op?.statusSummary?.orderConfimationEmailed
        loading = true
        await createOperationOut(op)
            .then(async (res) => {
                const r = (await createPDFAndGetOperation(res)) as OperationOut
                if (!newTab) {
                    dispatch("hideOverlay")
                    navigateTo(`/de/operations-out?type=${r.type}&id=` + r.id)
                } else {
                    openOverlay(r)
                }
                if (r?.statusSummary?.created !== 100) {
                    newNotification({
                        class: "warning",
                        html: `${$_("components.operationDetails.offerTemplate")} ${
                            r.type == 1
                                ? $_("components.operationDetails.offer")
                                : $_("components.operationDetails.orderConfirmation")
                        } ${$_("components.operationDetails.isNotCompleted")}`,
                    })
                } else {
                    newNotification({
                        class: "success",
                        html: `${
                            r.type == 1
                                ? $_("components.operationDetails.offer")
                                : $_("components.operationDetails.orderConfirmation")
                        } ${$_("components.operationDetails.wasSuccessfullyCreated")}`,
                    })
                }
            })
            .catch((e) => {
                console.error("Error while creating operation", e)
                newNotification({
                    class: "error",
                    html: `${
                        op.type == 1
                            ? $_("components.operationDetails.offer")
                            : $_("components.operationDetails.orderConfirmation")
                    } ${$_("components.operationDetails.couldNotBeCreated")}: ${e?.message}`,
                    timeout: 10000,
                })
            })
            .finally(() => {
                loading = false
            })
    }

    let orderedOperationStatus = {
        available: false,
        notCanceled: false,
        withNotCanceledPositions: false,
    }

    let activePositions = op?.positions?.length
    $: {
        if (op) {
            activePositions = op.positions.filter((p) => p.orderQuantity == undefined || p.orderQuantity > 0).length
        }
    }
    let operationHashCurrent: any

    $: {
        if (!$operationHashBeginning && op && op.collectionName == "operation-out") {
            op?.additionalPositions?.forEach((e) => {
                if (isNaN(e.amount) || e.amount < 1) e.amount = 1
            })
            op?.positions?.forEach((e) => {
                e?.additionalItems?.forEach((e) => {
                    if (isNaN(e.amount) || e.amount < 1) e.amount = 1
                })
            })
            op?.positions?.forEach((e) => {
                if (isNaN(e?.endCustomerPrice)) {
                    e.endCustomerPrice = e.netPrice
                    e.endCustomerPriceGross = e.netPrice * 1.19
                }
            })
            op = operationSumEndcustomerPrice(op)[0]

            $operationHashBeginning = hash(op)
        }
    }

    function checkIfOfferChanged(params: any) {
        if (!params?.id || params.id == op?.id) {
            if (offerChanged) return false
            else return true
        } else return true
    }

    registerEventCallback("closeOpTab", checkIfOfferChanged)

    let offerChanged = false
    onMount(() => {
        let interval = setInterval(() => {
            if ($operationHashBeginning) {
                let notEmailed =
                    op?.type == 1
                        ? !(op?.statusSummary as OperationOutStatusSummary)?.emailed
                        : !(op?.statusSummary as OperationOutStatusSummary)?.orderConfimationEmailed
                if (op && hash(op) != $operationHashBeginning && notEmailed) offerChanged = true
                else offerChanged = false
            }
        }, 200)
        return () => {
            clearInterval(interval)
        }
    })
    onDestroy(() => {
        $operationHashBeginning = null
        unregisterEventCallback("closeOpTab", checkIfOfferChanged)
    })
    async function getAttachments() {
        if (op && op?.id) {
            delete attachmentsProm[op.number]
            files = await loadAttachments(op)
            $filesStore[op.id] = files
        }
    }

    async function setOrderedOperationStatus(
        op: Operation | OperationOut,
        orderedOperationStatus: { available: boolean; notCanceled: boolean; withNotCanceledPositions: boolean }
    ) {
        orderedOperationStatus = await checkIfOrderedAndItsStatus(op, orderedOperationStatus)
        refresh = !refresh
    }
    $: {
        if (loading === false) {
            files = null
            getAttachments()
        }
    }
    $: setOrderedOperationStatus(op, orderedOperationStatus)

    $: somePositionsSelected = op?.positions?.some((p) => p.orderQuantity !== 0)
    let refreshElements = false
    let orderedOperation: null = null
    let refresh = false
    let showTemplate = false

    async function convertInOperationConfirmation() {
        let positionGroups: {
            [key: string]: OperationPositions[]
        } = {}
        // wenn positionen aus mehreren ausgangsangeboten kommen,
        // dann gruppiere diese,
        // damit mehrere Auftragsbestätigungen erstellt werden
        op.positions.forEach((p, i) => {
            if (p.status.blockingIndicator == 2) return
            if (p.operationOutOfferReference) {
                positionGroups[p.operationOutOfferReference.id] = positionGroups[p.operationOutOfferReference.id] || []
                positionGroups[p.operationOutOfferReference.id].push(JSON.parse(JSON.stringify(p)))
            } else {
                positionGroups["noRef"] = positionGroups["noRef"] || []
                positionGroups["noRef"].push(JSON.parse(JSON.stringify(p)))
            }
        })

        let index = 0
        for (const [_, value] of Object.entries(positionGroups)) {
            const operation = JSON.parse(JSON.stringify(op))
            operation.positions = value
            operation.applyOperationOutOffer = true
            // Warten, bis makeNewOperationOut für das aktuelle Element abgeschlossen ist
            await makeNewOperationOut(operation, index !== 0)
            index += 1
        }
    }

    async function setTemplateExists() {
        templateExists = await checkIfTemplateOnOpOrOnClerkIsAvailable(op, $login?.account?.ident?.dealerNumber)
        templateExists = templateExists || false
    }

    let templateExists: boolean = null
    $: if (templateExists === null && !!op && !!$login?.account?.ident?.dealerNumber) {
        setTemplateExists()
    }
</script>

{#if !op}
    <div style="padding-top: 50px; padding-left: 50px;">
        <MiniLoader />
    </div>
{:else}
    {#key refreshElements}
        {#key operationHashCurrent}
            {#if op.collectionName === "operation-out" && !op.statusSummary?.emailed && !op.statusSummary?.orderConfimationEmailed}
                <OperationEdit bind:operation="{op}" />
            {:else if op}
                <OperationHead bind:operation="{op}" />
            {/if}
        {/key}
        {#if loading}
            <div style="padding: 50px;">
                <MiniLoader />
            </div>
        {:else if offerChanged && op.collectionName == "operation-out" && !op.statusSummary?.emailed && !op.statusSummary?.orderConfimationEmailed}
            <p style="margin: 20px;">{$_("components.operationDetails.saveToGeneratePDF")}</p>
        {:else if files == null}
            {#if $filesStore[op?.id]?.length && !loading}
                {#each $filesStore[op?.id].filter((f) => !f.name.match(/^\d{7,8}_\d{3}\-/)) as file}
                    {#if $login?.tokenData?.roles?.includes("A") || !file.name.match(/\.xml$/)}
                        <AttachementField
                            viaId="{collectionName == 'operation-out'}"
                            {file}
                            operation="{op}"
                            className="overlay_auftrag"
                        />
                    {/if}
                {/each}
            {:else}
                <MiniLoader />
            {/if}
        {:else if files?.length}
            <div class="attachements">
                {#each files.filter((f) => !f.name.match(/^\d{7,8}_\d{3}\-/)) as file}
                    {#if $login.tokenData.roles.includes("A") || !file.name.match(/\.xml$/)}
                        {#if (op.type == 1 && file.name.replace(/^.+\-([^\.]+)\.[^\.]+/, "$1") !== "OrderConfirmation") || (op.type == 2 && file.name.replace(/^.+\-([^\.]+)\.[^\.]+/, "$1") !== "A")}
                            <AttachementField
                                viaId="{collectionName == 'operation-out'}"
                                {file}
                                operation="{op}"
                                className="overlay_auftrag"
                            />{/if}
                    {/if}
                {/each}
            </div>
        {/if}

        <OperationPositions
            {...$$props}
            bind:operation="{op}"
            overlay="{true}"
            bind:activePosition
            {loadAttachments}
            on:positionSeletion="{(e) => {
                op = e.detail.operation
            }}"
            on:operationDeletion="{(e) => {
                dispatch('closeTab')
            }}"
            on:updated="{(e) => {
                op = e.detail.operation
            }}"
        />

        {#if op.collectionName == "operation-out"}
            <PricegroupSelect bind:operation="{op}" />

            <OperationSummary bind:operation="{op}" />
        {/if}

        {#if op?.type === 1 && !location?.pathname?.includes("cart") && ($login?.account?.roles?.includes("A") || $login?.account?.permissions?.includes("B"))}
            <div
                class="add_to_cart"
                use:tooltip="{{
                    content:
                        activePositions == 0 ? $_('components.operationDetails.selectAtLeastOnePosition') : 'invalid',
                }}"
            >
                <button
                    class="btn btn-outline btn-label-sm"
                    on:click="{async () => {
                        clicked = true
                    }}"
                    class:deactivate="{activePositions == 0}"
                >
                    <div class="wrapper">
                        <div class="text">
                            {activePositions}
                            {$_("components.operationDetails.markedPositionsToCart")}
                        </div>
                        {#key orderedOperation}
                            <CartIcon operation="{orderedOperation || op}" details="{true}" bind:clicked />
                        {/key}
                    </div>
                </button>
            </div>
        {/if}
    {/key}
    <div class="overlay_legends">
        <OperationsLegend type="{op.type}" />
    </div>
    <div style="flex-grow: 1; flex-shrink: 0; min-height: 120px;"></div>

    <div class="overlay_buttons bookmark">
        <div class="layout layout-gap-sm align-items-center">
            {#key [somePositionsSelected, offerChanged, refresh]}
                {#if $login?.account.roles?.includes("A") || $login?.account.permissions?.includes("O")}
                    {#if !isOperationOut(op)}
                        {#if op.type == 1}
                            {#key [somePositionsSelected, templateExists, loading]}
                                <div
                                    style="position: relative;"
                                    use:tooltip="{{
                                        content: getOfferConvertionTooltip(somePositionsSelected, templateExists),
                                    }}"
                                >
                                    <button
                                        class="btn btn-secondary btn-with-icon"
                                        name="convertToOffer"
                                        disabled="{checkIfOfferConvertionIsDisabled(
                                            loading,
                                            somePositionsSelected,
                                            templateExists
                                        )}"
                                        on:click="{() => {
                                            makeNewOperationOut(toOperationOut(op))
                                        }}"
                                    >
                                        <div class="icon">
                                            <Icon path="{mdiFileDocumentEdit}" size="24px" />
                                        </div>
                                        <span
                                            >{$_("components.operationDetails.convertToCustomerOffer")}<br />{$_(
                                                "components.operationDetails.transformTo"
                                            )}</span
                                        >
                                    </button>
                                </div>
                            {/key}
                        {/if}
                        {#if op.collectionName == "operation" && op.type == 2}
                            {#key [somePositionsSelected, templateExists, orderedOperationStatus]}
                                <div
                                    style="position: relative;"
                                    use:tooltip="{{
                                        content: getOrderConfirmationConvertionTooltip(
                                            somePositionsSelected,
                                            op,
                                            templateExists
                                        ),
                                    }}"
                                >
                                    <button
                                        class="btn btn-secondary btn-with-icon"
                                        name="convertToOrderConfirmation"
                                        disabled="{checkIfOrderConfirmationConvertionIsDisabled(
                                            loading,
                                            somePositionsSelected,
                                            op,
                                            templateExists
                                        )}"
                                        on:click="{convertInOperationConfirmation}"
                                    >
                                        <div class="icon">
                                            <Icon path="{mdiFileDocumentEdit}" size="24px" />
                                        </div>
                                        <span
                                            >{$_("components.operationDetails.convertToOrderConfirmation")}<br />{$_(
                                                "components.operationDetails.transformTo"
                                            )}</span
                                        >
                                    </button>
                                </div>
                            {/key}
                        {/if}
                    {/if}
                {/if}
                {#if isOperationOut(op)}
                    <div style="display: flex; flex-direction: column;  position: relative;">
                        {#key [offerChanged, op]}
                            {#if offerChanged && !op.statusSummary?.emailed && !op.statusSummary?.orderConfimationEmailed}
                                <div
                                    style="position: relative;"
                                    use:tooltip="{{
                                        content: getResetTooltip(offerChanged, op),
                                    }}"
                                >
                                    <button
                                        class=""
                                        style="border: 0px; padding: 0px; background: transparent; position: absolute; top: -20px;"
                                        on:click="{async () => {
                                            if ($appliedPricegroups?.[op?.id]) delete $appliedPricegroups[op?.id]
                                            await getOp(true)
                                            $operationHashBeginning = hash(op)
                                            operationHashCurrent = hash(op)
                                            refreshElements = !refreshElements
                                        }}">{$_("general.reset")}</button
                                    >
                                </div>
                            {/if}
                        {/key}
                        {#key [offerChanged, somePositionsSelected, op]}
                            <div
                                style="position: relative;"
                                use:tooltip="{{
                                    content: getSaveTooltip(offerChanged, somePositionsSelected, op),
                                }}"
                            >
                                <button
                                    class="btn btn-secondary btn-blue"
                                    disabled="{checkIfSaveIsDisabled(op, loading, offerChanged, somePositionsSelected)}"
                                    on:click="{() => {
                                        if (
                                            $appliedPricegroups?.[op?.id] &&
                                            hash(op) !== $appliedPricegroups?.[op?.id]?.[1]
                                        ) {
                                            $appliedPricegroups[op?.id] = ['Manuelle Angabe', hash(op)]
                                            if (isOperationOut(op) && op.appliedPCalc) op.appliedPCalc = ''
                                        }

                                        saveOp(true)
                                    }}">{$_("general.save")}</button
                                >
                            </div>
                        {/key}
                    </div>

                    {#key op}
                        <div
                            style="position: relative;"
                            use:tooltip="{{
                                content: getEditTemplateTooltip(op),
                            }}"
                        >
                            <button
                                class="btn btn-secondary btn-with-icon"
                                disabled="{checkIfEditTemplateIsDisabled(loading, somePositionsSelected, op)}"
                                on:click="{() => {
                                    showTemplate = true
                                }}"
                            >
                                <div class="icon">
                                    <Icon path="{mdiFileDocumentMultiple}" size="24px" />
                                    <div class="mobile">{$_("components.documentTemplate.template")}</div>
                                </div>
                                <span>{$_("components.documentTemplate.editTemplate")}</span>
                            </button>
                        </div>
                    {/key}
                    {#if op.type === 1}
                        {#key [offerChanged, op]}
                            <div
                                style="position: relative;"
                                use:tooltip="{{
                                    content: getSendOfferTooltip(offerChanged, op),
                                }}"
                            >
                                <button
                                    disabled="{checkIfSendOfferIsDisabled(
                                        loading,
                                        offerChanged,
                                        op,
                                        somePositionsSelected
                                    )}"
                                    name="sendToCustomer"
                                    class="btn btn-secondary btn-with-icon"
                                    on:click="{() => {
                                        openOverlay(op, 'email', {
                                            operation: op,
                                            type: 'sendOffer',
                                        })
                                    }}"
                                >
                                    <div class="icon">
                                        <Icon path="{mdiEmailArrowRight}" size="24px" />
                                        <div class="mobile">{$_("general.email")}</div>
                                    </div>
                                    <span>{@html $_("components.operationDetails.sendOfferToCustomer")}</span>
                                </button>
                            </div>
                        {/key}
                        {#key [offerChanged, orderedOperationStatus, op, somePositionsSelected]}
                            <div
                                style="position: relative;"
                                use:tooltip="{{
                                    content: getCreateOfferConfirmationTooltip(
                                        offerChanged,
                                        orderedOperationStatus,
                                        op,
                                        somePositionsSelected
                                    ),
                                }}"
                            >
                                <button
                                    class="btn btn-secondary btn-with-icon"
                                    disabled="{checkIfOfferCreationIsDisabled(
                                        orderedOperationStatus,
                                        offerChanged,
                                        op,
                                        loading,
                                        somePositionsSelected
                                    )}"
                                    on:click="{async () => {
                                        const opOut = JSON.parse(JSON.stringify(op))
                                        opOut.type = 2
                                        const query = {
                                            type: 2,
                                            'positions.operationOutOfferReference.id': op.id,
                                        }
                                        const resp = await getOperation('operation', query)
                                        const orderedOperation = resp?.data?.[0]
                                        if (!orderedOperation) return
                                        orderedOperation.positions = orderedOperation.positions.filter(
                                            (p) => p?.operationOutOfferReference?.id == op.id
                                        )
                                        await makeNewOperationOut(toOperationOut(orderedOperation))
                                    }}"
                                >
                                    <div class="icon">
                                        <Icon path="{mdiFileDocumentMultiple}" size="24px" />
                                        <div class="mobile">{$_("components.operationDetails.orderConfirmation")}</div>
                                    </div>
                                    <span>{@html $_("components.operationDetails.createOrderConfirmationAndEdit")}</span
                                    >
                                </button>
                            </div>
                        {/key}
                    {/if}
                    {#if op.type == 2}
                        {#key [offerChanged, orderedOperationStatus, op]}
                            <div
                                style="position: relative;"
                                use:tooltip="{{
                                    content: getSendOfferConfirmationTooltip(offerChanged, orderedOperationStatus, op),
                                }}"
                            >
                                <button
                                    name="sendToCustomer"
                                    class="btn btn-secondary btn-with-icon"
                                    disabled="{checkIfOfferConfirmationIsDisabled(
                                        orderedOperationStatus,
                                        offerChanged,
                                        op,
                                        loading,
                                        somePositionsSelected
                                    )}"
                                    on:click="{async () => {
                                        loading = true
                                        await sendOfferConfirmation(toOperationOut(op))
                                        loading = false
                                    }}"
                                >
                                    <div class="icon">
                                        <Icon path="{mdiEmailArrowRight}" size="24px" />
                                        <div class="mobile">{$_("general.email")}</div>
                                    </div>
                                    <span
                                        >{@html $_("components.operationDetails.sendOrderConfirmationToCustomer")}</span
                                    >
                                </button>
                            </div>
                        {/key}
                    {/if}
                    {#key [offerChanged, somePositionsSelected]}
                        <div
                            style="position: relative;"
                            use:tooltip="{{
                                content: getDuplicateOperationTooltip(offerChanged, somePositionsSelected),
                            }}"
                        >
                            <button
                                class="btn btn-secondary btn-with-icon"
                                disabled="{checkIfOperationDuplicationIsDisabled(
                                    loading,
                                    offerChanged,
                                    somePositionsSelected
                                )}"
                                name="duplicateOperation"
                                on:click="{() => {
                                    makeNewOperationOut(toOperationOut(op))
                                }}"
                            >
                                <div class="icon">
                                    <Icon path="{mdiFileDocumentMultiple}" size="24px" />
                                    <div class="mobile">{$_("general.duplicate")}</div>
                                </div>
                                <span
                                    >{op.type == 1 ? $_("operations.offerT") : $_("operationsOut.orderConfirmation")}
                                    {@html $_("operations.duplicateAndEdit")}</span
                                >
                            </button>
                        </div>{/key}
                    <div></div>
                {/if}
            {/key}
        </div>
        <div class="layout layout-gap-md align-items-center">
            {#if isOperationOut(op) && op.type === 1}
                <section>
                    <button
                        class="btn btn-link btn-label-sm"
                        on:click="{() => {
                            openOverlay(op, 'protocol', {
                                operation: op,
                            })
                        }}"
                    >
                        <Icon path="{mdiArchiveClock}" size="24px" />
                        <span class="label">{$_("components.operationProtocol.protocol").toUpperCase()}</span>
                    </button>
                </section>
            {/if}

            <section class="layout layout-gap-sm">
                <!-- svelte-ignore a11y-no-static-element-interactions -->

                <div style="width: 150px; height: 40px;">
                    <FollowUpButton operation="{op}" personNumber="{$login?.account?.ident?.personNumber}" />
                </div>
                <ShareOperation operation="{op}" />
            </section>
        </div>
    </div>
{/if}

{#if op && op.collectionName == "operation-out"}
    {#key op}
        <OperationTemplateOverlay
            bind:show="{showTemplate}"
            operation="{JSON.parse(JSON.stringify(op))}"
            on:save="{(e) => {
                if (!isOperationOut(op)) return
                op.documentTemplateTextContent = e.detail.operation.documentTemplateTextContent
                op.baseTemplate = e.detail.operation.baseTemplate
                if (e.detail.initial) {
                    $operationHashBeginning = hash(op)
                }
            }}"
        />{/key}
{/if}
